import { render, staticRenderFns } from "./ProjectGroupDocumentListingTable.vue?vue&type=template&id=1a4d604b"
import script from "./ProjectGroupDocumentListingTable.vue?vue&type=script&lang=js"
export * from "./ProjectGroupDocumentListingTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports